import { useCallback, useLayoutEffect, useState } from "react";

export function usePopupPosition(iconRef, isOpen) {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // eslint-disable-next-line
  const updatePosition = useCallback(() => {
    const viewportWidth = window.innerWidth;
    const modalMaxWidth = 650;
    const rightMargin = 20;
    const topMargin = 50;
    
    // Calculate left position to align modal from the right side
    // Account for transform: translateX(-90%) which shifts modal 90% of its width to the left
    // So actual visual left = left - (modalMaxWidth * 0.9)
    // We want: visual left + modalMaxWidth + rightMargin = viewportWidth
    // Therefore: left = viewportWidth - rightMargin - (modalMaxWidth * 0.1)
    const calculatedLeft = viewportWidth - rightMargin - (modalMaxWidth * 0.1);
    
    setPosition({
      top: topMargin,
      left: calculatedLeft,
    });
  }, []);

  useLayoutEffect(() => {
    if (isOpen) {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition);
      return () => {
        window.removeEventListener("resize", updatePosition);
        window.removeEventListener("scroll", updatePosition);
      };
    }
  }, [isOpen, updatePosition]);

  return { position };
}
